import { commonActions } from '../actions';

export const sessionIsCurrent = (jwt) => (dispatch) => {
  const { setValue } = commonActions('SESSION_VALUE');
  dispatch(setValue({ currentSession: jwt }));
};

export const fetchedConfig = () => (dispatch) => {
  const { setValue } = commonActions('FETCH_CONFIG_STATUS');
  dispatch(setValue());
};
